import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";

interface ColumnJobHeaderProps {
    jobName: string;
}

const ColumnJobHeader: React.FC<ColumnJobHeaderProps> = ({ jobName }) => {
    return (
        <Tooltip title={jobName}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%",
                    padding: "0 8px",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontSize: "12px",
                        fontWeight: 500,
                        lineHeight: "16px",
                        color: "#49454F",
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {jobName}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export default ColumnJobHeader;
